export default function Projects() {
  const projects = [
    {
      title: "E-commerce Sentiment Analysis",
      desc: "Customer review analysis with sentiment prediction.",
      github: "https://github.com/ranjeetgtm/ecommerce-sentiment-analysis",
    },
    {
      title: "Online Appointment System",
      desc: "Hospital appointment & patient management system.",
      github: "https://github.com/ranjeetgtm/online-appointment-system",
    },
    {
      title: "College Website",
      desc: "Responsive academic website with admin features.",
      github: "https://github.com/ranjeetgtm/collegewebsite",
      
    },
  ];

  return (
    <section id="projects" className="py-28 bg-gray-100 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <h3 className="text-3xl font-bold mb-12 text-center">
          Selected Projects
        </h3>

        <div className="grid md:grid-cols-3 gap-8">
          {projects.map(p => (
            <div
              key={p.title}
              className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow hover:-translate-y-2 transition"
            >
              <h4 className="font-semibold text-lg">{p.title}</h4>
              <p className="mt-2 text-gray-600 dark:text-gray-300">
                {p.desc}
              </p>
              <a
                href={p.github}
                target="_blank"
                className="inline-block mt-4 text-blue-600 font-medium"
              >
                View on GitHub →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
